import { useMutation } from '@tanstack/react-query';
import { publicApi } from '../../api/api';
import { useAuth } from '../context/AuthProvider';
import loginDataSchema from '../schemas/loginDataSchema';
import loginResponseSchema from '../schemas/loginResponseSchema';
import { z } from 'zod';
import { useNavigate } from 'react-router';
import { AxiosError } from 'axios';
import { getRedirectPathFromPermissions } from '../utils/getRedirectPathFromPermissions';
import { User } from '../types/User';

type LoginData = z.infer<typeof loginDataSchema>;
type LoginResponse = z.infer<typeof loginResponseSchema>;

export const useLogin = () => {
    const { login } = useAuth();
    const navigate = useNavigate();

    return useMutation<LoginResponse, AxiosError, LoginData>({
        mutationFn: async (data) => {
            const response = await publicApi.post<LoginResponse>('/v4/login', data);
            return response.data;
        },
        onSuccess: (response) => {
            // login(data.data, data.token);

            const userDataForAuth: User = {
                id: response.data.id,
                name: response.data.name,
                email: response.data.email,
                role: response.data.role,
                permissions: response.data.permissions,
                properties: response.data.properties,
                active_property_id: response.data.active_property_id,
                active_property: response.data.active_property,
                company: response.data.company,
                is_full_sync: response.data.is_full_sync,
                phone: response.data.phone
            };

            login(userDataForAuth, response.token);

            const permissions = response.data?.permissions || [];
            const redirectPath = getRedirectPathFromPermissions(permissions);

            // navigate('/');
            navigate(redirectPath);
        },
    });
};
